export const BOOKMARKED_TOOLTIP_MESSAGE = 'Remove from bookmarks';
export const BOOKMARK_TOAST_ID = 'bookmark-toast';
export const FOR_YOU = 'For You';
export const NOT_BOOKMARKED_TOAST_MESSAGE = 'Removed from bookmarks';
export const NOT_BOOKMARKED_TOOLTIP_MESSAGE = 'Save for later reading';
export const SAVE_BOOKMARK_ERROR_MESSAGE = 'Unable to update bookmarks';

export enum BookmarkSize {
  Small = 16,
  Large = 36,
  ArticleActions = 40,
}

export function getBookmarkErrorMessage(error: unknown): string {
  if (
    error &&
    typeof error === 'object' &&
    'error' in error &&
    typeof error.error === 'string' &&
    error.error.length > 0
  ) {
    return error.error;
  }

  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message.length > 0
  ) {
    return error.message;
  }

  return SAVE_BOOKMARK_ERROR_MESSAGE;
}
